import React, { useState } from "react";
import { Container, Navbar, Offcanvas } from "react-bootstrap";
import SidebarContent from "../SideBar/SidebarContent";
import SidebarHeader from "../SideBar/SidebarHeader";

function MobileNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const expand = "md";

  return (
    <>
      <Navbar
        expand={expand}
        collapseOnSelect
        className="bg-white mb-3 d-md-none"
      >
        <Container fluid>
          <Navbar.Toggle
            aria-controls={`offcanvasNavbar-expand-${expand}`}
            onClick={toggleMenu}
          />
          <Navbar.Brand>
            <SidebarHeader />
          </Navbar.Brand>
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-${expand}`}
            aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
            placement="start"
            show={menuOpen}
            onHide={() => setMenuOpen(false)}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                <SidebarHeader />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <SidebarContent onLinkClick={toggleMenu} />
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </>
  );
}

export default MobileNavbar;
